/**
 * 趋势分析、品牌网络、ASIN轨迹、市场变化 API
 */

import api from './client';

export const trendAPI = {
    list: (params?: { sku_id?: number; keyword?: string; period_id?: number }) =>
        api.get('/trends/', { params }),
    bySku: (skuId: number) => api.get(`/trends/by_sku/`, { params: { sku_id: skuId } }),
    byKeyword: (skuId: number, keyword: string) =>
        api.get(`/trends/by_keyword/`, { params: { sku_id: skuId, keyword } }),
    generate: (skuId: number) => api.post(`/trends/generate/`, { sku_id: skuId }),
};

export const brandNetworkAPI = {
    forSku: (skuId: number, periodId?: number, topN: number = 50) =>
        api.get(`/brand-network/for_sku/`, { params: { sku_id: skuId, period_id: periodId, top_n: topN } }),
    generate: (skuId: number, periodIds?: number[], topN: number = 50) =>
        api.post(`/brand-network/generate/`, { sku_id: skuId, period_ids: periodIds, top_n: topN }),
    brandDetails: (skuId: number, periodIds?: number[]) =>
        api.get(`/brand-network/brand_details/`, { params: { sku_id: skuId, period_ids: periodIds?.join(',') } }),
};

export const asinTrajectoryAPI = {
    list: (params?: { keyword?: string; asin?: string; period_id?: number }) =>
        api.get(`/asin-trajectories/`, { params }),
    byKeyword: (keyword: string, skuId?: number, topN: number = 10) =>
        api.get(`/asin-trajectories/by_keyword/`, { params: { keyword, sku_id: skuId, top_n: topN } }),
};

export const marketShiftAPI = {
    list: (params?: { sku_id?: number; winner_brand?: string; loser_brand?: string; min_confidence?: number }) =>
        api.get(`/market-shifts/`, { params }),
    generate: (skuId: number, fromPeriodId: number, toPeriodId: number) =>
        api.post(`/market-shifts/generate/`, { sku_id: skuId, from_period_id: fromPeriodId, to_period_id: toPeriodId }),
};
